'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixRestaurantsDriver = function () {
    function WixRestaurantsDriver(_ref) {
        var nockable = _ref.nockable;

        _classCallCheck(this, WixRestaurantsDriver);

        this._nockable = nockable;
    }

    _createClass(WixRestaurantsDriver, [{
        key: 'start',
        value: function start() {
            return this._nockable.start();
        }
    }, {
        key: 'stop',
        value: function stop() {
            return this._nockable.stop();
        }
    }, {
        key: 'reset',
        value: function reset() {
            return this._nockable.reset();
        }
    }, {
        key: 'getOrganization',
        value: function getOrganization(_ref2) {
            var organizationId = _ref2.organizationId,
                _ref2$fields = _ref2.fields,
                fields = _ref2$fields === undefined ? null : _ref2$fields;

            return this._aRequestFor({
                request: {
                    type: 'get_organization',
                    organizationId: organizationId,
                    fields: fields
                }
            });
        }
    }, {
        key: 'getOrganizationFull',
        value: function getOrganizationFull(_ref3) {
            var organizationId = _ref3.organizationId,
                _ref3$fields = _ref3.fields,
                fields = _ref3$fields === undefined ? null : _ref3$fields;

            return this._aRequestFor({
                request: {
                    type: 'get_organization_full',
                    organizationId: organizationId,
                    fields: fields
                }
            });
        }
    }, {
        key: 'setOrganization',
        value: function setOrganization(_ref4) {
            var organization = _ref4.organization,
                accessToken = _ref4.accessToken;

            return this._aRequestFor({
                request: {
                    type: 'set_organization',
                    organization: organization,
                    accessToken: accessToken
                }
            });
        }
    }, {
        key: 'submitOrder',
        value: function submitOrder(_ref5) {
            var _ref5$accessToken = _ref5.accessToken,
                accessToken = _ref5$accessToken === undefined ? null : _ref5$accessToken,
                order = _ref5.order;

            return this._aRequestFor({
                request: {
                    type: 'submit_order',
                    accessToken: accessToken,
                    order: order
                }
            });
        }
    }, {
        key: 'getRole',
        value: function getRole(_ref6) {
            var accessToken = _ref6.accessToken,
                organizationId = _ref6.organizationId;

            return this._aRequestFor({
                request: {
                    type: 'get_role',
                    accessToken: accessToken,
                    organizationId: organizationId
                }
            });
        }
    }, {
        key: '_aRequestFor',
        value: function _aRequestFor(_ref7) {
            var _this2 = this;

            var request = _ref7.request;

            var params = {
                request: request
            };

            var _this = {
                delayBy: function delayBy(_ref8) {
                    var ms = _ref8.ms;

                    params.delay = ms;
                    return _this;
                },

                succeedWith: function succeedWith(response) {
                    // response can be an object with {value:...}, or a function
                    params.response = response;

                    _this2._addRule(params);
                },

                failWith: function failWith(_ref9) {
                    var code = _ref9.code,
                        description = _ref9.description;

                    params.response = { error: code, errorMessage: description };
                    params.error = true;

                    _this2._addRule(params);
                },

                failWithProtocolError: function failWithProtocolError() {
                    params.response = '<html></html>';

                    _this2._addRule(params);
                }
            };

            return _this;
        }
    }, {
        key: '_addRule',
        value: function _addRule(_ref10) {
            var request = _ref10.request,
                _ref10$delay = _ref10.delay,
                delay = _ref10$delay === undefined ? 0 : _ref10$delay,
                response = _ref10.response;

            this._nockable.nock.post('', request).delayConnection(delay).times(-1).reply(200, response);
        }
    }]);

    return WixRestaurantsDriver;
}();

exports.default = WixRestaurantsDriver;